import { getLang, urlHelper } from "helpers/themeHelpers";
import { ICityLiteAsset } from "models/Assets/ICityAsset";

export const linkPrayerTimes = (country: string = null) => {
  const locale = getLang();
  if (process.env.NEXT_PUBLIC_CUSTOM_THEME==="shobiddak" || country === "ps") {
    return `${process.env.NEXT_PUBLIC_SHO_BIDAK_BASE_URL}/prayers/cities`
  }
  return `/${locale}/${locale === "ar" ? "أوقات-الصلاة" : "prayer-times"}`;
};

export const LinkPrayerTimeCity = (city: ICityLiteAsset) => {
  const locale = getLang();
  return `/${locale}/${
    locale === "ar" ? "أوقات-الصلاة" : "prayer-times"
  }/${urlHelper(city)}`;
};
